import { render, staticRenderFns } from "./Motivos.vue?vue&type=template&id=340dba21&scoped=true"
import script from "./Motivos.vue?vue&type=script&lang=js"
export * from "./Motivos.vue?vue&type=script&lang=js"
import style0 from "./Motivos.vue?vue&type=style&index=0&id=340dba21&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "340dba21",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VBreadcrumbsItem } from 'vuetify/lib/components/VBreadcrumbs';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VBreadcrumbs,VBreadcrumbsItem,VBtn,VIcon,VSkeletonLoader})
